import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from "./store"
import authentication from './authentication'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requiresAuthentication: true
            },
            beforeEnter: (to, from, next) => {
                store.dispatch("establecerUsuario").then(response => {
                    next();
                }, error => {
                    //authentication.signOut();
                })
            }
        },
        {
            path: '/nuevo',
            name: 'nuevo',
            props: true,
            meta: {
                requiresAuthentication: true
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Nuevo.vue')
        },        
        {
            path: '/editar',
            name: 'editar',
            props: true,
            meta: {
                requiresAuthentication: true
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/Nuevo.vue')
        },       
        {
            path: '/admin',
            name: 'admin',
            meta: {
                requiresAuthentication: true
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/admin.vue')
        } 
    ]
})
